import { render, staticRenderFns } from "./PartnersIndex.vue?vue&type=template&id=0a08a65f&"
import script from "./PartnersIndex.vue?vue&type=script&lang=js&"
export * from "./PartnersIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports